const iconMap = {
  phone: 'PhoneCall',
  email: 'Email',
  link: 'Link',
  date: 'Calendar',
  social: 'Social',
  default: 'Settings',
};

export default iconMap;
